import {
  deleteContactResponsibleCompany,
  insertContactResponsibleCompany,
} from "../actions";
import { promiseLimit } from "./promiseLimit";

export function getResponsavelPorToAdd(responsavelPor, responsavelPorInDb) {
  return responsavelPor.filter(
    (company) =>
      !responsavelPorInDb.some((companyInDb) => companyInDb.id === company.id),
  );
}

export async function InsertContactsResponsibleCompany(
  companysToAdd,
  contactId,
  userId,
  addItemsToResponsavelPorInDb = () => {},
  removeFailedItems = () => {},
) {
  if (companysToAdd.length === 0) return [];
  const limit = promiseLimit(50);
  const results = await Promise.all(
    companysToAdd.map((company) =>
      limit(
        insertContactResponsibleCompany,
        contactId,
        company.id,
        userId,
        company.label,
        addItemsToResponsavelPorInDb,
        removeFailedItems,
      ),
    ),
  );

  // a action retorna a response em caso de sucesso e undefined no catch,
  // então as empresas sem response são as que falharam
  const failedCompanys = companysToAdd.filter(
    (_company, index) => !results[index],
  );
  return failedCompanys;
}

export function getResponsavelPorToDelete(responsavelPor, responsavelPorInDb) {
  return responsavelPorInDb.filter(
    (companyInDb) =>
      !responsavelPor.some((company) => company.id === companyInDb.id),
  );
}

export async function DeleteContactResponsibleCompany(
  companysToDelete,
  contactId,
  userId,
  removeItemsToResponsavelPorInDb = () => {},
) {
  if (companysToDelete.length === 0) return [];
  const limit = promiseLimit(50);
  const results = await Promise.all(
    companysToDelete.map((company) =>
      limit(
        deleteContactResponsibleCompany,
        contactId,
        company.id,
        userId,
        company.label,
        removeItemsToResponsavelPorInDb,
      ),
    ),
  );

  // a action retorna a response em caso de sucesso e undefined no catch,
  // então as empresas sem response são as que falharam
  const failedCompanys = companysToDelete.filter(
    (_company, index) => !results[index],
  );
  return failedCompanys;
}
